const $ = require("jquery");

userSettings.leftRight = false
userSettings.leftRightWidth = -1
userSettings.colorizeOutput = true
userSettings.phpversions = false;
userSettings.hidePHPVerionsList = false;
userSettings.hideSandboxText = false;
userSettings.userUseAltEnter = true;
userSettings.userLoadLastCode = true;

function isTrue(setting) {
    return setting !== undefined && (setting === true || setting === "true")
}

let options = {}
let stored = localStorage.getItem('userSettings');
if (stored) {
    options = JSON.parse(stored);
}

// Default userSettings
for (const [option, value] of Object.entries(userSettings)) {
    userSettings[option] = value;
    $(".user-options-select[name='" + option + "']").val(value);
    $(".user-options[name='" + option + "']").prop('checked', isTrue(value));
}

if (options) {
    // override by user userSettings
    for (const [option, value] of Object.entries(options)) {
        userSettings[option] = value;
        $(".user-options-select[name='" + option + "']").val(value);
        $(".user-options[name='" + option + "']").prop('checked', isTrue(value));
    }
}
